/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=d1ecea4e"
const script = {}

import exportComponent from "E:\\Program\\nodejs\\aegis-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__